import { ConfirmSheet } from '@/components/ConfirmSheet'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
} from '@/components/ModalSheet'

export interface RemoveTeamMemberDialogProps {
  showing: boolean
  displayName: string
  isRemovePending: boolean
  onConfirm: () => void
  onDecline: () => void
}

/**
 * Asks to confirm removing a member from a team.
 */
export function RemoveTeamMemberDialog({
  showing,
  displayName,
  isRemovePending,
  onConfirm,
  onDecline,
}: RemoveTeamMemberDialogProps) {
  return (
    <ConfirmSheet
      title="Confirm removal"
      yes="Remove Team Member"
      no="No"
      danger
      showing={showing}
      isPending={isRemovePending}
      onConfirm={onConfirm}
      onDecline={onDecline}
    >
      <ModalSheetContentBlock>
        <ModalSheetContentDescription>
          Are you sure you want to remove <strong>{displayName}</strong>? You
          can invite them back again later.
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>
    </ConfirmSheet>
  )
}
